import { mapRoutes } from './map'
import { listRoutes } from './list'

export default [...mapRoutes, ...listRoutes]
